import { useId } from 'react';
import { useStats } from 'react-instantsearch';

import type {
    SortByItem,
    SortProductsProps,
} from '@app/plp/components/SortProduct';

import '@app/plp/components/SortProduct/SortProduct.scss';
import SortProductOptionIcon from '@app/plp/components/SortProduct/SortProductOptionIcon';
import { analyticsSortProducts } from '@libs/algolia';
import { dataLayerPush, trackPLPSortingOptions } from '@libs/analytics';
import { closeButtonDropdown } from '@app/plp/utils/closeButtonDropdown';

export default function SortProduct({
    type,
    currentRefinement,
    options,
    refine,
}: SortProductsProps) {
    const id = useId();
    const { nbHits } = useStats();

    const sortByAnalytics = (value: string, label: string) => {
        if (currentRefinement !== value) {
            refine(value);
            dataLayerPush({
                event: 'product_list_sort',
                sort_order: analyticsSortProducts[value],
                results: nbHits,
            });
            trackPLPSortingOptions(label);
            closeButtonDropdown();
        }
    };

    return (
        <div className="sort-product" data-testid="sort-product">
            {options.map(({ label, value }: SortByItem) => (
                <button
                    type="button"
                    className="sort-product__item"
                    key={`${id}-${label}-${value}`}
                    onClick={() => sortByAnalytics(value, label)}
                    data-testid={`sort-product-by-${label}`}
                >
                    <SortProductOptionIcon
                        type={type}
                        value={value}
                        currentRefinement={currentRefinement}
                    />
                    <span className="sort-product__item--label">{label}</span>
                </button>
            ))}
        </div>
    );
}
